module.exports = __webpack_public_path__ + "img/3-3-2-5.f0ff33bf.png";